import { useCommanKit } from "../../Hooks/Features/WelcomeKit/useCommanKit"
import { dateConvert, RenderSignatureField } from "../../utils/Helper";

const ReleaseForm = ({ data, onPrev, onNext, readOnly }) => {

    const { signature, handleChange, handleRemove } = useCommanKit({ data });
    const paragraphs = [
        `I hereby authorize (The Company) and/or their authorized representatives and contractors to verify information presented on my employment application/resume and to procure an investigative report or consumer report for that purpose.`,
        `I hereby grant authority for the bearer of this letter to access or be provided with full details of my previous employment record held by any company or business for whom I previously worked. This information should include the dates of employment; the nature of the position held, [details of my salary upon departure] and an appraisal of my performance, capabilities and character.`,
        `In addition, please provide any other pertinent information requested by the individual presenting this authority. I hereby release from liability all persons or entities requesting or supplying such information of my qualification/degree (copy of my certificates attached).`,
        `I also give my consent to the Administration Department and permit them to use the information provided by me during the time of appointment for administrative purposes.`,
        `The company can use/share my information for different purposes like I-card, account opening & insurance.`,
        `Information in respect to my character from the records maintained by local authorities.`
    ];

    return (
        <div className='d-flex justify-content-center mx-1'>
            <div className='w100 my-2'>
                <div className="">
                    <section>
                        <h4 className="p-2 mb-3" style={{ background: "#f2f2f2" }}>
                            Information Release Form
                        </h4>
                        <h5 className="p-2 mb-3 text-center">To Whom It May Concern</h5>
                        <p className="my-2">
                            I <b>{data?.employee?.user_display_name}</b>
                        </p>
                        {paragraphs.map((text, idx) => (
                            <p className={`my-2${idx === paragraphs.length - 1 ? " text-center" : ""}`} key={idx}>
                                {text}
                            </p>
                        ))}
                    </section>
                </div>
                <div className="d-flex justify-content-between align-items-center my-3">
                    <div>
                        Date: <b>{dateConvert(new Date(), "day-mon-year")}</b>
                    </div>
                    <div>
                        {!readOnly && <RenderSignatureField name="user_signature_url" handleChange={handleChange} value={signature} handleRemove={handleRemove} />}
                        Employee Signature
                    </div>
                </div>
                {
                    !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                        <button className='btn-default' onClick={onPrev}>Previous</button>
                        <button className='btn-primary' onClick={onNext}>Proceed</button>
                    </div>
                }

            </div>
        </div>
    )
}

export default ReleaseForm